import Vue from 'vue';
import { ValidationProvider, extend , ValidationObserver, localize } from 'vee-validate';
import ko from 'vee-validate/dist/locale/ko.json';
import * as rules from 'vee-validate/dist/rules';
import { extract } from '../utils/utils';

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});



/**
 * @description: 확장자 체크(ex rules="extension:mp3,jpg")
 */
extend('extension', {
    validate(value, args) {
        const fileName = value[0].name;
        const extension = fileName.split('.').pop().toLowerCase();

        console.log('extension : ', extension);

        let diffExtension = ''; //비교 확장자
        if (Array.isArray(args.ext)) {
            diffExtension = args.ext.join(',');
        } else {
            diffExtension = args.ext;
        }

        let reg = new RegExp(extension);
        let testing = reg.test(diffExtension);

        if (testing) {
            return true;
        }
        return `${diffExtension} 형식만 사용가능합니다.`;
    },
    params: ['ext'],
});


/**
 * @description: 파일 사이즈 체크(MB기준)
 */
extend('filesize', {
    validate(value, args) { 
        const fileSize = args.size;
        const aleterFileSize = fileSize * 1024 * 1024; //2번 곱하면 MB

        if (value[0].size <= aleterFileSize) {
            return true;
        }

        return `파일사이즈가 ${fileSize}MB 이하여야만 합니다.`;
    },
    params:['size']
})

localize('ko',ko);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


// WEBPACK FOOTER //
// ./src/plugins/veevalidate.js